import { Box, Radio, Stack, Typography } from '@mui/material'
import { useCallback, useState } from 'react'

import { Printer } from './GetPrinters'
import PreviewAndPrint from './PreviewAndPrint'

interface Props {
  printers: Printer[]
}

const SelectPrinter = ({ printers }: Props) => {
  const [selectedPrinter, setSelectedPrinter] = useState<number | undefined>(
    printers.length === 1 ? 0 : undefined
  )

  const selectPrinter = useCallback(
    (index: number) => {
      if (printers.length <= 1) {
        return
      }
      if (selectedPrinter === index) {
        setSelectedPrinter(undefined)
      } else {
        setSelectedPrinter(index)
      }
    },
    [printers.length, selectedPrinter]
  )

  return (
    <>
      <Typography variant="h6">Select Printer</Typography>
      <Stack
        direction="row"
        alignContent="center"
        alignItems="center"
        spacing={2}>
        {printers.length > 1 &&
          printers.map((printer, index) => (
            <div key={'Printer #' + index} onClick={() => selectPrinter(index)}>
              <Box
                sx={{
                  border: '1px solid #302B54',
                  borderRadius: 4,
                  cursor: 'pointer'
                }}>
                <Stack
                  direction="row"
                  alignContent="center"
                  alignItems="center"
                  spacing={2}
                  padding={2}>
                  <Radio checked={selectedPrinter === index} />
                  <Box>
                    <Typography>{'Printer #' + (index + 1)}</Typography>
                    <Typography>{printer.name}</Typography>
                  </Box>
                </Stack>
              </Box>
            </div>
          ))}
      </Stack>
      {selectedPrinter !== undefined && selectedPrinter < printers.length && (
        <PreviewAndPrint printer={printers[selectedPrinter]} />
      )}
    </>
  )
}

export default SelectPrinter
